module.exports = __webpack_public_path__ + "img/coin-group.bf39a197.png";